exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".save-file-btn[data-v-56762171]{position:fixed;bottom:12vh;right:2vw;z-index:100}.pdf-viewer-iframe-wrapper.pdf-viewer-resizing iframe[data-v-56762171]{pointer-events:none;opacity:.3;-webkit-transition:opacity .2s;transition:opacity .2s;height:0!important;width:0!important}.pdf-viewer-resizing[data-v-56762171]{background-color:rgb(42 42 46);width:100%!important;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
